import type { BaggageConditionType } from '@/components/FlightSummary/BaggageCondition/types';

export const baggageConditionToKey = {
  CHECKIN_INCLUDED: 'flightSummary.segment.baggage.checkInBaggage',
  CABIN_INCLUDED: 'flightSummary.segment.baggage.handBaggage',
  BASED_ON_AIRLINE: 'flightSummary.segment.baggage.smallBaggage',
};
const baggageKeysAlias = {
  CHECKIN_INCLUDED: 'flightSummary.segment.baggage.alias.checkInBaggage',
  CABIN_INCLUDED: 'flightSummary.segment.baggage.alias.handBaggage',
  BASED_ON_AIRLINE: 'flightSummary.segment.baggage.alias.smallBaggage',
};

export const getBaggageKey = (
  baggageCondition: BaggageConditionType,
  isBagsNamingCleanupEnabled?: boolean
) => {
  if (isBagsNamingCleanupEnabled) {
    return baggageKeysAlias[baggageCondition];
  }
  return baggageConditionToKey[baggageCondition];
};
